import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgPicturesOutline = function SvgPicturesOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 3H5.75C4.23122 3 3 4.23122 3 5.75V16.25V18.25C3 19.7688 4.23122 21 5.75 21H16.25H18.25C19.7688 21 21 19.7688 21 18.25V5.75C21 4.23122 19.7688 3 18.25 3ZM18.25 4.5H5.75C5.05964 4.5 4.5 5.05964 4.5 5.75V14.4394L6.05546 12.8839C7.1294 11.8099 8.8706 11.8099 9.94454 12.8839L16.5606 19.5H18.25C18.9404 19.5 19.5 18.9404 19.5 18.25V5.75C19.5 5.05964 18.9404 4.5 18.25 4.5ZM8.88388 13.9445C8.39573 13.4564 7.60427 13.4564 7.11612 13.9445L4.5 16.5606V18.25C4.5 18.9404 5.05964 19.5 5.75 19.5H14.4394L8.88388 13.9445Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 12.25C16.0188 12.25 17.25 11.0188 17.25 9.5C17.25 7.98122 16.0188 6.75 14.5 6.75C12.9812 6.75 11.75 7.98122 11.75 9.5C11.75 11.0188 12.9812 12.25 14.5 12.25ZM14.5 10.75C15.1904 10.75 15.75 10.1904 15.75 9.5C15.75 8.80964 15.1904 8.25 14.5 8.25C13.8096 8.25 13.25 8.80964 13.25 9.5C13.25 10.1904 13.8096 10.75 14.5 10.75Z"
  })));
};

export { SvgPicturesOutline as ReactComponent };
//# sourceMappingURL=pictures_outline.svg.js.map
